import { useContext, useEffect, useState } from "react"
import { Stack, Alert, Button, Box, LinearProgress } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";
import API from "../../services/API";
import Loader from "../Tools/Loader";
import Tracker from "../../services/Tracker";
import UserContext from "../../services/Context/UserContext";
import Layout from "./components/Layout";
import { ArrowBack } from "@mui/icons-material";

export default function Free(){

    const { id } = useParams()

    const { user } = useContext(UserContext)

    const [status, setStatus] = useState('loading')

    useEffect(() => {

        API.get(`/courses/${id}/free`)
            .then(r => {
                
                setStatus('success')

                Tracker.trackEnrollment({
                    id: Date.now(),
                    value: 0,
                    product: r.data,
                    mode: 'offert',
                    user: user
                })

                setTimeout(() => setStatus('redirect'), 4000)

            })
            .catch(e => setStatus(e.response.status === 409 ? 'conflict' : 'error'))
        

    }, [id, user])


    if( status === 'redirect' ) return <Navigate to="/" />


    return (

        <Layout>

            <Stack direction='column' spacing={3} sx={{maxWidth: 600, margin: 'auto'}}>


                {status === 'loading' &&
                    <Loader />
                }

                {status === 'success' && 

                    <Box>

                        <LinearProgress color='success' />

                        <Alert severity='success'>
                            Votre inscription a bien été prise en compte. Vous allez être redirigé sur votre tableau de bord.
                        </Alert>

                    </Box>
                }

                {status === 'error' && 
                    <Alert severity='error'>
                        Une erreur s'est produite. Votre inscription n'a pas été prise en compte.
                    </Alert>
                }

                {status === 'conflict' &&
                    <Alert severity='success'>
                        Votre inscription a bien été prise en compte.
                    </Alert>
                }

                {status !== 'loading' &&
                    <Button
                        onClick={() => setStatus('redirect')}
                        startIcon={<ArrowBack />}
                    >
                        Retour à l'accueil
                    </Button>
                }

            </Stack>

        </Layout>
    );

}